import type { ReactNode } from "react";

interface PrettyRequestWrapperProps {
    icon: ReactNode;
    title: string;
    description?: string;
    children: ReactNode;
}

export default function PrettyRequestWrapper(
    { icon, title, description, children }: PrettyRequestWrapperProps,
) {
    return (
        <div className="flex flex-col items-center gap-6 mx-auto px-4 py-12 max-w-xl">
            <div className="flex flex-col items-center gap-2">
                {icon}
                <h1 className="mb-1 font-bold text-2xl text-center tracking-tight">
                    {title}
                </h1>
                {description && (
                    <p className="max-w-md text-slate-600 text-base text-center">
                        {description}
                    </p>
                )}
            </div>
            {children}
        </div>
    );
}
